import { render, staticRenderFns } from "./AboutContactPage.vue?vue&type=template&id=0d01ab93&scoped=true"
import script from "./AboutContactPage.vue?vue&type=script&lang=js"
export * from "./AboutContactPage.vue?vue&type=script&lang=js"
import style0 from "./AboutContactPage.vue?vue&type=style&index=0&id=0d01ab93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d01ab93",
  null
  
)

export default component.exports